import styled from 'styled-components';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';

export const UsersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

export const UsersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchSection = styled.div`
  flex: 1;
  min-width: 300px;
`;

export const FilterButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: #c82333;
    border-color: #bd2130;
    color: white;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const AddButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #28a745;
  border-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: #218838;
    border-color: #1e7e34;
    color: white;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
  }
`;

export const UserCard = styled.div`
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

export const UserInfo = styled.div`
  flex: 1;
  margin-bottom: 1rem;
`;

export const UserName = styled.h5`
  color: #212529;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
`;

export const UserEmail = styled.p`
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  word-break: break-word;
`;

export const UserRole = styled.span`
  display: inline-block;
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

export const UserActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const ActionButton = styled(Button)`
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const EditButton = styled(ActionButton)`
  background-color: #ffc107;
  color: #212529;

  &:hover {
    background-color: #e0a800;
    color: #212529;
  }
`;

export const DeleteButton = styled(ActionButton)`
  background-color: #dc3545;
  color: white;

  &:hover {
    background-color: #c82333;
    color: white;
  }
`;

// Modal Styles
export const ModalHeader = styled(Modal.Header)`
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  border-radius: 0.5rem 0.5rem 0 0;

  .modal-title {
    font-weight: 600;
    color: #212529;
  }
`;

export const ModalBody = styled(Modal.Body)`
  padding: 2rem;
`;

export const ModalFooter = styled(Modal.Footer)`
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  border-radius: 0 0 0.5rem 0.5rem;
  padding: 1rem 2rem;
  gap: 0.5rem;
`;

// Form Styles
export const FormGroup = styled(Form.Group)`
  margin-bottom: 1.5rem;
`;

export const Label = styled(Form.Label)`
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
`;

export const Input = styled(Form.Control)`
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.75rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &.is-invalid {
    border-color: #dc3545;
  }

  &.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
`;

export const Select = styled(Form.Select)`
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.75rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &.is-invalid {
    border-color: #dc3545;
  }

  &.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }
`;

// --- Grade/Tabela no estilo do Service Desk ---
export const Container = styled.div`
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.02) 0%, rgba(244, 241, 222, 0.05) 100%);
  border-radius: 12px;
  padding: 20px;
  margin: 10px 0;
`;

export const TableBox = styled.div`
  border: 1px solid rgba(26, 26, 46, 0.1);
  border-radius: 12px;
  overflow-x: auto;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(26, 26, 46, 0.12);
  }
`;

export const CustomTableHead = styled.thead`
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.05) 0%, rgba(26, 26, 46, 0.02) 100%);
  border-bottom: 2px solid rgba(26, 26, 46, 0.1);
`;

export const CustomTableBody = styled.tbody`
  background: rgba(255, 255, 255, 0.95);
`;

export const CustomTableRow = styled.tr`
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(26, 26, 46, 0.05);

  &:hover {
    background: rgba(26, 26, 46, 0.02);
    transform: translateY(-1px);
  }

  &:nth-child(even) {
    background: rgba(244, 241, 222, 0.03);
  }
`;

export const CustomTH = styled.th`
  padding: 16px 12px !important;
  text-align: left !important;
  border-bottom: 2px solid rgba(26, 26, 46, 0.1) !important;
  color: #1a1a2e !important;
  font-family: 'Nunito', sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.05) 0%, rgba(26, 26, 46, 0.02) 100%) !important;
  transition: all 0.2s ease !important;

  &:hover {
    background: linear-gradient(135deg, rgba(26, 26, 46, 0.08) 0%, rgba(26, 26, 46, 0.04) 100%) !important;
    color: #1a1a2e !important;
  }
`;

export const CustomTD = styled.td`
  padding: 16px 12px;
  border-bottom: 1px solid rgba(26, 26, 46, 0.05);
  color: #1a1a2e;
  font-size: 14px;
  vertical-align: middle;
`;

export const ActionsTH = styled(CustomTH)`
  text-align: center !important;
`;

export const CustomTable = styled.table`
  margin: 0;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
`;

// Filtros (estilo do Service Desk)
export const FilterSection = styled.div`
  display: flex;
  flex: 1;
  gap: 1rem;
  align-items: center;
  min-width: 300px;
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const FilterInputContainer = styled.div`
  flex: 2;
`;

export const FilterSelectContainer = styled.div`
  flex: 1;
`;

export const CustomInputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchIconBox = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  color: #a7a7a7;
  font-size: 20px;
`;

export const CustomFormControl = styled.input`
  padding-left: 32px;
  border-radius: 50px !important;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 32px;
  background: #ffffff;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: text !important;
  caret-color: #0d6efd !important;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: text !important;
    caret-color: #0d6efd !important;
  }

  &::placeholder {
    color: #a7a7a7;
    font-style: italic;
  }
`;

export const CustomSelectRounded = styled.select`
  padding-left: 15px;
  border-radius: 50px !important;
  color: #a7a7a7;
  font-style: italic;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 15px;
  background: #ffffff;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: pointer !important;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: pointer !important;
  }
`;

// Botões com mesmo estilo do Service Desk
export const CustomButton = styled.button`
  border: 1px solid #6c757d;
  color: #6c757d;
  background: #ffffff;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;

  &:hover {
    background: #6c757d;
    color: #ffffff;
    border-color: #6c757d;
  }

  &:active {
    transform: translateY(0);
  }
`;

// Botão de ação da lista (igual ao Service Desk/Incidents)
export const ListActionButton = styled.button`
  background: rgba(26, 26, 46, 0.1);
  border: 1px solid rgba(26, 26, 46, 0.2);
  color: #1a1a2e;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;

  &:hover {
    background: #1a1a2e;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &.primary:hover { background: #1a1a2e; }
  &.secondary:hover { background: #6b7280; }
  &.danger:hover { background: #dc2626; }
  &.info:hover { background: #0891b2; }
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;

  &.status-active {
    background: rgba(25, 135, 84, 0.15);
    color: #0a3622;
    border: 1px solid rgba(25, 135, 84, 0.3);
  }

  &.status-inactive {
    background: rgba(108, 117, 125, 0.15);
    color: #495057;
    border: 1px solid rgba(108, 117, 125, 0.3);
  }
`;
